import { jsx } from 'react/jsx-runtime';
import '../../menu/menu/index.esm.js';
import '../../menu/menu-trigger/index.esm.js';
import '../../menu/menu-container/index.esm.js';
import { EGDSMenuList } from '../../menu/menu-list/index.esm.js';
import '../../menu/menu-list-item/index.esm.js';
import '../../menu/menu-icon-trigger/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-skip-link.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextProvider } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSSkipLink = props => {
  const {
    className,
    id,
    items
  } = props;
  const wrapperClassNames = getClassNameList('uitk-skip-link uitk-skip-link-is-visually-hidden', className);
  const contextData = {
    isInSkipLink: true
  };
  return jsx("div", {
    id: id,
    className: wrapperClassNames,
    children: jsx(EGDSContextProvider, {
      config: {
        context: 'egds-skip-link-context',
        data: contextData
      },
      children: jsx(EGDSMenuList, {
        items: items
      })
    })
  });
};
EGDSSkipLink.displayName = 'EGDSSkipLink';
export { EGDSSkipLink };